import styled from 'styled-components';
import { device, mtrStyle } from 'src/styles/global';
import { Button } from '@dsny/dsny-component-library';
import theme from 'src/styles/theme';

export interface Props {
  $isClickable?: boolean;
  $isBillingPage?: boolean;
}

export const PurchaseWrapper = styled.div<Props>`
  min-height: calc(100vh - 160px);
  padding-top: ${({ $isBillingPage }) => ($isBillingPage ? '0px' : '48px')};
  padding-right: 64px;
  padding-left: 64px;
  padding-bottom: 120px;

  @media ${device.mobile} {
    padding: 100px 0px 16px;
  }

  @media ${device.tablet} {
    padding-left: 0px;
    padding-right: 0px;
  }

  @media ${device.ipad} {
    padding-left: 0px;
    padding-right: 0px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  max-width: 1071px;

  @media ${device.mobile} {
    max-width: 288px;
  }

  @media ${device.tablet} {
    width: 90%;
  }

  @media ${device.ipad} {
    width: 90%;
  }
`;

export const FormBox = styled.form`
  display: flex;
  flex-direction: column;
  position: inherit;
  padding: 32px 32px;
  border-radius: ${mtrStyle.borderRadius};
  box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.08);
  background-color: ${theme.colors.white0};

  @media ${device.mobile} {
    padding: 24px 24px;
  }
`;

export const StepsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  padding-bottom: 24px;
  font-size: 14px;
  color: ${theme.colors.neutralW40};

  @media ${device.mobile} {
    font-size: 12px;
    padding-bottom: 24px;
  }
`;

export const ClickableStep = styled.div<Props>`
  display: flex;
  flex-direction: row;
  align-items: center;
  font-weight: 700;
  cursor: ${({ $isClickable }) => ($isClickable ? 'pointer' : '')};
`;

// Wrapper for modal buttons
export const FlexButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 16px;
`;

// Wrapper for main buttons in the main container
export const MainFlexButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  gap: 16px;

  @media ${device.mobile} {
    flex-direction: column-reverse;
    justify-content: center;
  }
`;

export const FormButton = styled(Button)`
  min-width: 72px;

  @media ${device.mobile} {
    width: 100%;
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const DeleteButtonWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const DeleteButton = styled.button`
  display: flex;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  padding: 8px;
  font-family: ${theme.fonts.primary};

  &:hover {
    border-radius: 50px;
    background: ${theme.colors.neutralW100};
  }

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const ModalCancelButton = styled(Button)`
  width: 104px;
  height: 36px;
  border-radius: 5px;
`;

export const ModalContinueButton = styled(Button)`
  width: 88px;
`;

export const ModalGoToDashboardButton = styled(Button)`
  width: fit-content;
`;

export const ModalDeleteSongButton = styled(Button)`
  width: 110px;
  height: 36px;
  border-radius: 5px;
`;

export const ErrorWrapper = styled.div`
  margin-bottom: 32px;

  @media ${device.mobile} {
    margin-bottom: 24px;
  }
`;

export const HeadingDeleteSongModal = styled.div`
  font-size: 24px;
  font-weight: 700;
  line-height: 33px;
  color: ${theme.colors.neutralW20};
  margin-bottom: 8px;
`;

export const TextDeleteSongModal = styled.p`
  font-size: 14px;
  line-height: 19px;
  color: ${theme.colors.neutralW20};
  margin-bottom: 32px;
`;

export const BillingHeading = styled.div`
  font-size: 36px;
  font-weight: 700;
  color: ${theme.colors.neutralW20};
  margin-bottom: 24px;

  @media ${device.mobile} {
    font-size: 30px;
    margin-bottom: 16px;
  }
`;

export const BillingInformationWrapper = styled.div`
  padding-bottom: 40px;

  @media ${device.mobile} {
    padding-bottom: 32px;
  }
`;

export const BillingInformationText = styled.div`
  font-size: 16px;
  font-weight: 700;
  color: ${theme.colors.neutralW20};
  width: fit-content;
  padding: 8px;
  border-bottom: 1px solid ${theme.colors.mtr60};
`;

export const BillingInformationLine = styled.div`
  border-bottom: 1px solid ${theme.colors.neutralW80};
`;

export const ModalPurchaseSucessHeading = styled.div`
  font-size: 24px;
  font-weight: 700;
  color: ${theme.colors.neutralW20};
  margin-bottom: 8px;
`;

export const ModalPurchaseSucessBody = styled.div`
  font-size: 14px;
  color: ${theme.colors.neutralW20};
  margin-bottom: 32px;
`;
